// DS: DS6.1 - Button Semantics
import { _ as _extends } from "@swc/helpers/_/_extends";
import { _ as _object_destructuring_empty } from "@swc/helpers/_/_object_destructuring_empty";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import omit from 'lodash/omit';
import { EffectStrength, useListItem } from '../../common';
import { setRef } from '../../../../../utils/refHelpers';
import PlainButtonOrLink from '../../../../Buttons/PlainButtonOrLink';
import ListItemContent from '../../legos/ListItemContent';
const ListItemButton = (unfilteredProps)=>{
    const _useListItem = useListItem(unfilteredProps, {
        hover: EffectStrength.Strong
    }), { contentProps, ref } = _useListItem, rest = _extends({}, _object_destructuring_empty(_useListItem.rootProps));
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, _object_spread({
        innerRef: (node)=>setRef(ref, node)
    }, omit(rest, 'checked')), /*#__PURE__*/ React.createElement(ListItemContent, contentProps));
};
ListItemButton.displayName = 'ListItemButton';
export default ListItemButton;

//# sourceMappingURL=ListItemButton.js.map